import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { trackVideoStarted, trackYoutubeVideoStarted, trackYoutubeVideoEnded, trackYoutubeVideoPosition, trackVideoPosition, trackVideoEnded } from './metrics.external-script.js';
import { VideoTypes } from './types.js';
import css_248z from './video-player.scss.js';
import { playIfRequested, vimeoEmbedSrc, initAndPlayYoutube, upgradeVimeoDntOnConsent, whenYoutubeConsent, initYoutubePlayer } from './youtube-bootstrap.js';
export { YOUTUBE_CONSENT_GROUP, hasYoutubeConsent, loadYoutubeIframeAPIScript, onYtReady, requestYoutubePlayerInit, whenYoutubeConsent } from './youtube-bootstrap.js';

class VideoPlayer extends s {
    constructor() {
        super();
        this.usedInFullImageVideo = false;
        this.usedInInlineFullVideo = false;
        this.reduceAnimation = false;
        this.usedInInline = false;
        this.insideTextBlock = false;
        this.isVideoStarted = false;
        this.player = null;
        this.GET_IFRAME_PARAMS = () => ({
            YouTube: `?playsinline=1&modestbranding=1${this.usedInFullImageVideo ? '&autoplay=1&loop=1&mute=1&controls=0' : ''}`,
            Vimeo: `?background=${this.usedInFullImageVideo ? '1' : '0'}`,
            inInlineFull: '&autoplay=1',
        });
        this.videoStartedHandler = (e, id) => {
            if (this.isVideoStarted)
                return;
            this.isVideoStarted = true;
            trackVideoStarted(e, id);
        };
        this.onYouTubePlayerStateChange = (event) => {
            switch (event.data) {
                case window.YT.PlayerState.ENDED:
                    trackYoutubeVideoEnded(this.player.getVideoUrl(), this.player.getVideoData().title);
                    break;
                case window.YT.PlayerState.PLAYING:
                    if (!this.isVideoStarted) {
                        trackYoutubeVideoStarted(this.player.getVideoUrl(), this.player.getVideoData().title);
                        setInterval(() => this.player.trackPostionHanler(this.player.getVideoUrl(), this.player.getVideoData().title, this.player.getDuration(), this.player.getCurrentTime(), event.data === window.YT.PlayerState.PLAYING), 300);
                        this.isVideoStarted = true;
                    }
                    break;
            }
        };
        this.onYouTubePlayerReady = () => {
            this.player.trackPostionHanler = trackYoutubeVideoPosition();
            playIfRequested(this);
        };
        this.playWhenReady = false;
        this.trackVideoPosition = trackVideoPosition();
        this.renderVideoBlock = () => {
            let iframeSrc = '';
            switch (this.type) {
                case VideoTypes.LOCAL:
                    return $ `<div class="video-player-wrapper">${this.renderLocalVideo(this.usedInFullImageVideo)}</div>`;
                case VideoTypes.YOUTUBE:
                    iframeSrc = `https://www.youtube-nocookie.com/embed/${this.videoId + this.setIframeParams(VideoTypes.YOUTUBE)}`;
                    return this.usedInFullImageVideo
                        ? $ `<iframe title="youtube player" .src="${iframeSrc}" allowfullscreen allow="autoplay"></iframe>`
                        : $ `<div id="player_${this.videoId}"></div>`;
                case VideoTypes.VIMEO:
                    iframeSrc = vimeoEmbedSrc(this.videoId, this.setIframeParams(VideoTypes.VIMEO));
                    return $ `<iframe title="vimeo player" .src="${iframeSrc}" allowfullscreen allow="autoplay"></iframe>`;
                default:
                    return null;
            }
        };
        this._query = '(max-width: 767px)';
        this._isMobile = false;
        this._isAutoplay = !!(this.autoplay && !this._isMobile);
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
    _triggerLocalVideo() {
        var _a;
        if (this._isAutoplay &&
            this.type === VideoTypes.LOCAL &&
            this.usedInFullImageVideo) {
            const video = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('video');
            video.muted = !!this.muted;
            video === null || video === void 0 ? void 0 : video.play();
        }
    }
    // Lightbox contract: it calls videoPlayer.initAndPlay() on open.
    initAndPlay() {
        return initAndPlayYoutube(this);
    }
    firstUpdated() {
        var _a;
        const parentVideoBlock = this.parentElement;
        if ((_a = parentVideoBlock === null || parentVideoBlock === void 0 ? void 0 : parentVideoBlock.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains('rich-text')) {
            this.insideTextBlock = true;
        }
        upgradeVimeoDntOnConsent(this);
        if (this.type === VideoTypes.YOUTUBE && this.autoinit) {
            whenYoutubeConsent(() => initYoutubePlayer(this));
        }
    }
    updated() {
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reduceAnimation = !!(!mediaQuery || mediaQuery.matches);
        this._triggerLocalVideo();
        this._isAutoplay = !!(this.autoplay && !this.reduceAnimation);
    }
    renderLocalVideo(isBackgroundVideo) {
        const videoEl = o(`<source src="${this.videoId}" 
      type="video/mp4" />
      <track 
        src="${this.defaultClosedCaption}" 
        kind="subtitles" 
        srclang="en" 
        label="English" 
        default>
      `);
        return isBackgroundVideo
            ? $ `<video ?autoplay="${this._isAutoplay}" ?muted="${this.muted}" ?loop="${this.loop}" playsinline>${videoEl}</video>`
            : $ `<video @timeupdate="${(e) => this.trackVideoPosition(e, this.videoname)}" @play="${(e) => this.videoStartedHandler(e, this.videoname)}" @ended="${(e) => trackVideoEnded(e, this.videoname)}" controls playsinline>${videoEl}</video>`;
    }
    setIframeParams(videoType) {
        if (!this._isAutoplay)
            return '';
        let params = this.GET_IFRAME_PARAMS()[videoType];
        if (this.usedInInlineFullVideo) {
            params += this.GET_IFRAME_PARAMS().inInlineFull;
        }
        if (videoType === VideoTypes.YOUTUBE) {
            params += `&playlist=${this.videoId}`;
        }
        return params;
    }
    render() {
        return $ `<div class="video-container ${this.usedInFullImageVideo ? 'inFullImageVideo' : ''} ${this.usedInInlineFullVideo ? 'usedInInlineFullVideo' : ''} ${this.insideTextBlock ? 'insideTextBlock' : ''} ${this.usedInInline ? 'usedInInline' : ''}">${this.renderVideoBlock()}</div><lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query>`;
    }
}
VideoPlayer.styles = css_248z;
__decorate([
    e()
], VideoPlayer.prototype, "type", void 0);
__decorate([
    e()
], VideoPlayer.prototype, "videoId", void 0);
__decorate([
    e()
], VideoPlayer.prototype, "videoname", void 0);
__decorate([
    e({ type: String })
], VideoPlayer.prototype, "defaultClosedCaption", void 0);
__decorate([
    e({ type: Boolean })
], VideoPlayer.prototype, "autoinit", void 0);
__decorate([
    e({ type: Boolean })
], VideoPlayer.prototype, "autoplay", void 0);
__decorate([
    e({ type: Boolean })
], VideoPlayer.prototype, "muted", void 0);
__decorate([
    e({ type: Boolean })
], VideoPlayer.prototype, "loop", void 0);
__decorate([
    e({ type: Boolean })
], VideoPlayer.prototype, "usedInFullImageVideo", void 0);
__decorate([
    e({ type: Boolean })
], VideoPlayer.prototype, "usedInInlineFullVideo", void 0);
__decorate([
    e({ type: Boolean })
], VideoPlayer.prototype, "reduceAnimation", void 0);
__decorate([
    e({ type: Boolean })
], VideoPlayer.prototype, "usedInInline", void 0);
__decorate([
    t()
], VideoPlayer.prototype, "_isAutoplay", void 0);
customElements.define('video-player', VideoPlayer);

export { VideoPlayer };
